import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch, PropType } from "vue";
import { Bar } from "vue-chartjs";
import { Chart, ChartData, ChartOptions, registerables } from "chart.js";
import { CertificationCompliance } from "@/services/certification-compliance-service";

export interface complianceItem {
  percentage: number;
  month: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
  compliance: {
    type: Object as PropType<CertificationCompliance | undefined>,
    required: true,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

/* eslint-disable @typescript-eslint/no-unused-vars,  @typescript-eslint/ban-types */


Chart.register(...registerables);

const dataValues = ref<number[]>();
const dataLabels = ref<string[]>();

watch(
  () => props.compliance,
  () => {
    const values = props.compliance?.map((item: complianceItem) => {
      const value = parseInt(
        (Math.round(item.percentage * 100 + Number.EPSILON) / 100) * 100
      );
      return value;
    });

    const labes = props.compliance?.map((item: complianceItem) => item.month);
    dataLabels.value = labes;
    dataValues.value = values;
  }
);

const data = computed<ChartData<"bar">>(() => ({
  labels: dataLabels.value,
  datasets: [
    {
      label:'Porcentaje de cumplimiento mensual',
      data: dataValues.value,
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(255, 159, 64, 0.2)",
        "rgba(255, 205, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(201, 203, 207, 0.2)",
        "rgba(255, 99, 132, 0.2)",
        "rgba(255, 159, 64, 0.2)",
        "rgba(255, 205, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(54, 162, 235, 0.2)",
      ],
    },
  ],
}));

const options = computed<ChartOptions<"bar">>(() => ({
  scales: {
    y: {
      max: 100,
      title: { display: true, text: "Porcentajes (%)" },
    },
    x: {
      title: { display: true, text: "Meses" },
    },
  },
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      text: "Porcentajes de transparencia mensual de la entidad",
      font: { size: 18 },
    },
  },
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Bar), { data: _unref(data) }, null, 8, ["data"])
  ]))
}
}

})